// extracted by mini-css-extract-plugin
export default {"wrapper":"hz-z","viewport":"iz-z","container":"jz-z","slide":"kz-z"};